import { render, staticRenderFns } from "./JdsNavigatorItem.vue?vue&type=template&id=1c499504&scoped=true&"
import script from "./JdsNavigatorItem.vue?vue&type=script&lang=ts&"
export * from "./JdsNavigatorItem.vue?vue&type=script&lang=ts&"
import style0 from "./JdsNavigatorItem.vue?vue&type=style&index=0&id=1c499504&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c499504",
  null
  
)

export default component.exports